import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    graphContainer: {
        height: '280px',
        marginRight: 10,
        padding: '10px',
        width: '100%'
    },
    logoContainer: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-around',
        width: '100%'
    },
    paper: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '280px',
        width: '100%',
        position: 'relative',
    },
    iconReset: {
        position: 'absolute',
        right: '10px',
    }
}));
